import { SecondaryButton } from '../views/components';
import { KitchenDeliveryConfig } from '../types/kitchen.types';

export const getKitchenConfigColumns = (
  handleEditConfig: (config: KitchenDeliveryConfig) => void,
  handleDeleteConfig: (code: string) => void,
  isDeleting: boolean
) => [
  {
    Header: 'Kitchen',
    accessor: 'kitchen.name',
    Cell: ({ cell: { value } }: any) => (
      <div className="font-medium">{value}</div>
    ),
  },
  {
    Header: 'Config status',
    accessor: 'isEnabled',
    Cell: ({ cell: { value } }: any) => (
      <span
        className={`px-2 py-1 rounded-md text-xs font-medium ${
          value ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
        }`}
      >
        {value ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    Header: 'Surge Pricing',
    accessor: 'enableSurge',
    Cell: ({ cell: { value }, row }: any) => (
      <div>
        <span
          className={`px-2 py-1 rounded-md text-xs font-medium ${
            value ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'
          }`}
        >
          {value ? 'Enabled' : 'Disabled'}
        </span>
        {value && (
          <div className="mt-1 text-xs text-gray-500">
            Multiplier: {row.original.surgeMultiplier}x
          </div>
        )}
      </div>
    ),
  },
  {
    Header: 'Weather Pricing',
    accessor: 'enableWeatherPricing',
    Cell: ({ cell: { value }, row }: any) => (
      <div>
        <span
          className={`px-2 py-1 rounded-md text-xs font-medium ${
            value ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'
          }`}
        >
          {value ? 'Enabled' : 'Disabled'}
        </span>
        {value && (
          <div className="mt-1 text-xs text-gray-500">
            Multiplier: {row.original.weatherMultiplier}x
          </div>
        )}
      </div>
    ),
  },
  {
    Header: 'Custom Rates',
    accessor: 'customDeliveryRates',
    Cell: ({ cell: { value } }: any) => (
      <div>
        <span className="font-medium">{value.length}</span>
        <span className="text-gray-500 text-sm">
          {' '}
          rate{value.length !== 1 ? 's' : ''}
        </span>
      </div>
    ),
  },
  {
    Header: 'Time Surge Rules',
    accessor: 'timeSurgePricing',
    Cell: ({ cell: { value } }: any) => (
      <div>
        <span className="font-medium">{value.length}</span>
        <span className="text-gray-500 text-sm">
          {' '}
          rule{value.length !== 1 ? 's' : ''}
        </span>
      </div>
    ),
  },
  {
    Header: 'Created',
    accessor: 'createdAt',
    Cell: ({ cell: { value } }: any) => (
      <div className="text-sm">
        {new Date(value).toLocaleDateString('en-GB', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        })}
      </div>
    ),
  },
  {
    Header: 'Actions',
    id: 'actions',
    Cell: ({ row }: any) => (
      <div className="flex space-x-2">
        <SecondaryButton
          text="Edit"
          onClick={() => handleEditConfig(row.original)}
          className="py-1 px-3 text-sm"
        />
        <SecondaryButton
          text="Delete"
          onClick={() => handleDeleteConfig(row.original.kitchen.code)}
          disabled={isDeleting}
          className="py-1 px-3 text-sm bg-red-50 text-red-700 border-red-200 hover:bg-red-100"
        />
      </div>
    ),
  },
];
